const envSiteUrl = process.env.VITE_SITE_URL || "https://seasoftclasses.com";
const envGaId = process.env.VITE_GA_ID || "G-XXXXXXXXXX";
const envGtmId = process.env.VITE_GTM_ID || "GTM-XXXXXXX";

export interface AddressConfig {
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface SocialConfig {
  facebook: string;
  linkedin: string;
  twitter: string;
  youtube: string;
  instagram: string;
}

export interface SEOConfig {
  siteName: string;
  siteUrl: string;
  defaultTitle: string;
  defaultDescription: string;
  defaultKeywords: string;
  defaultOgImage: string;
  twitterHandle: string;
  locale: string;
  phone: string;
  email: string;
  address: AddressConfig;
  social: SocialConfig;
  googleVerification: string;
  googleAnalyticsId: string;
  googleTagManagerId: string;
  googleAdsId: string;
}

export interface CourseDefaults {
  provider: string;
  providerUrl: string;
  mode: string;
  language: string;
  currency: string;
}

export const defaultSEO: SEOConfig = {
  siteName: "Seasoft Classes",
  siteUrl: envSiteUrl,
  defaultTitle: "Seasoft Classes | Online IT Training & Certification Courses",
  defaultDescription:
    "Live online IT training in Power BI, Salesforce, SAS, Java, Cybersecurity, PMP & 300+ more. Taught by certified industry experts. Enroll today.",
  defaultKeywords:
    "online IT training, IT certification courses, Power BI training, Salesforce course, SAS training, cybersecurity course, PMP certification, Java training USA",
  defaultOgImage: "/images/og-default.jpg",
  twitterHandle: "@seasoftclasses",
  locale: "en_US",
  phone: "+17087669765",
  email: "training@seasoftclasses.com",
  address: {
    street: "15 Huntington Circle",
    city: "Naperville",
    state: "IL",
    zip: "60540",
    country: "US",
  },
  social: {
    facebook: "https://www.facebook.com/SeasoftClasses/",
    linkedin: "https://www.linkedin.com/company/seasoft-classes",
    twitter: "https://x.com/Seasoft_Classes",
    youtube: "https://www.youtube.com/@ITTRAININGINUSA",
    instagram: "https://www.instagram.com/",
  },
  googleVerification: "YOUR_GOOGLE_VERIFICATION_CODE",
  googleAnalyticsId: envGaId,
  googleTagManagerId: envGtmId,
  googleAdsId: "AW-XXXXXXXXXX",
};

export const courseDefaults: CourseDefaults = {
  provider: "Seasoft Classes",
  providerUrl: "https://seasoftclasses.com",
  mode: "Online",
  language: "English",
  currency: "USD",
};
